import React from 'react';
import { Edit, required, SelectInput, TextInput } from 'react-admin';
import PersonalityQuizForm from './PersonalityQuizForm';
import { statuses } from '../../../config/constants';

const PersonalityQuizEdit = (props) => (
  <Edit title="Edit Personality Quiz" mutationMode="pessimistic" {...props}>
    <PersonalityQuizForm>
      <TextInput label="ID" source="id" disabled />
      <TextInput label="Name" source="name" validate={required()} />
      <SelectInput source="status" optionText="name" choices={statuses.slice(0, 2)} validate={required()} />
    </PersonalityQuizForm>
  </Edit>
);

export default PersonalityQuizEdit;
